import { QueryKey, useQuery } from '@tanstack/react-query';

import { getCmsContent } from '../cms/client';
import { UseZepApiQueryOptions } from '../zep-api/types/ZepApiQuery';

export const QUERY_KEY_CMS = 'cms';

export function useCmsContent<
  TQueryFnData extends readonly unknown[] | object = never,
  TData = TQueryFnData,
>(contentId: string, options?: UseZepApiQueryOptions<TQueryFnData, TData>) {
  return useQuery(
    [QUERY_KEY_CMS, contentId] as QueryKey,
    () => getCmsContent<TQueryFnData>({ contentId }),
    {
      // CMS 콘텐츠는 비필수 사이드 콘텐츠라 소비자가 data?. 로 방어한다.
      // 전역 QueryClient 의 useErrorBoundary:true 를 상속하면 콘텐츠 500 한 번에 GlobalErrorBoundary 로
      // 페이지 전체가 죽는다(PLAY-APP-AZY / WEB-APP-1RD/1QJ). 기본적으로 에러를 페이지로 던지지 않는다.
      // 관측성은 앱 QueryCache onError 가 handled 로 Sentry 에 남겨 유지한다.
      useErrorBoundary: false,
      // 캐싱 강화 + 백그라운드 패치 억제 (비필수 콘텐츠 → 재요청 최소화, hang 노출↓).
      staleTime: 10 * 60 * 1000,
      cacheTime: 60 * 60 * 1000,
      retry: 2,
      retryDelay: 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      ...options,
    },
  );
}
